import { ArrayHelpers, FormikProps } from "formik";
import { ReactNode } from "react";
import { ObjectSchema } from "yup";
import { IModalConditionalResult } from "../modal";
import { DotsTableView } from "dots-ui/dotsTable";

export const editableTableActionWidth = 100;

export type IEditableRowState = "View" | "Add" | "Edit" | "Delete";
export interface IEditableListRowState {
  rowState?: IEditableRowState;
  initialRowValue?: any;
}
export type IRowState<P> = P & IEditableListRowState;

export type IEditableRowValueType =
  | "String"
  | "Integer"
  | "Double"
  | "Date"
  | "Boolean";

export interface IAvisEditableListAddEditConfig<
  P extends IEditableListRowState,
> {
  //Set state to external modal/regular form
  customSetModalOpen?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;

  //Render subform with validation schema for add and edit values
  title?: string;
  renderForm?: (fBag: FormikProps<P>) => ReactNode;
  validationSchema?: ObjectSchema<P>;
}

export interface IAvisEditableListFieldConfig<P extends IEditableListRowState> {
  name: keyof P;
  title?: string;
  description?: string;
  required?: boolean;
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  shouldUpdateOnRender?: boolean;
  dataType?: IEditableRowValueType;
  forceEditMode?: boolean;
  forceViewMode?: boolean;
  transformViewValue?: (fieldValue: any, rowValue: P) => ReactNode;
  renderField?: (
    field: IAvisEditableListFieldConfig<P>,
    prefix: string,
    index: number,
    value: P,
    onChange: (e: any) => void,
  ) => ReactNode;
}

export interface IAvisEditableListProps<T, P extends IEditableListRowState> {
  bag: FormikProps<T>;
  bagField: keyof T;
  initValue: P;
  maxRows?: number;
  fields: IAvisEditableListFieldConfig<P>[];
  classNameField?: string;
  disabled?: boolean;
  loading?: boolean;
  hideEdit?: boolean;
  customAddEditConfig?: IAvisEditableListAddEditConfig<P>;
  customButtonAddText?: string;
  confirmBeforeDeleteOnAnyData?: boolean;
  forceUpdateKey?: any;
  /** Table view. */
  view?: DotsTableView;
  isDeletable?: (fieldValue: P) => boolean;
  confirmBeforeDelete?: (fieldValue: P) => IModalConditionalResult | undefined;
}
export interface IAvisEditableListFieldArrayProps<
  T,
  P extends IEditableListRowState,
> extends IAvisEditableListProps<T, P> {
  arrayHelpers: ArrayHelpers;
}
